<template>
  <div>
    <div class="overflow-hidden">
      <bimCol xxl=10 xl=8 sm=10 class="mx-auto">
        <BlockShowing @showModal="showModal = true" />
      </bimCol>
    </div>
    <bim-container class="services-lending__container">
      <bimCol xxl=10 xl=11 sm=12 class="mx-auto">
        <BlockServiceVideo @showModal="showModal = true" />
        <BlockPrivilege />
        <BlockDifference />
        <BlockEarlyAccess @showModal="showModal = true" />
        <BlockHowWork />
        <BlockQuestions />
        <BlockActionTime @showModal="showModal = true" />
      </bimCol>
      <bimPhoneRequest
        v-model="showModal"
        :userContext="user_info"
        :logActionEvent="$logActionEvent"
        apiPrefix="/web-api-2"
        :formType="2"
      />
    </bim-container>
  </div>
</template>

<script>
import bimCol from "@bimlib/components/bimCol"
import bimContainer from "@bimlib/components/bimContainer";
import bimPopup from "@bimlib/components/bimPopup";

import BlockShowing from "./components/BlockShowing";
import BlockPrivilege from "./components/BlockPrivilege";
import BlockDifference from "./components/BlockDifference";
import BlockEarlyAccess from "./components/BlockEarlyAccess";
import BlockHowWork from "./components/BlockHowWork";
import BlockQuestions from "./components/BlockQuestions";
import BlockActionTime from "./components/BlockActionTime";
import BlockServiceVideo from "./components/BlockServiceVideo";

import bimPhoneRequest from '@bimlib/components/bimPhoneRequest'

export default {
  name: "smpp",
  components: {
    bimCol,
    bimContainer,
    bimPopup,

    BlockShowing,
    BlockPrivilege,
    BlockDifference,
    BlockEarlyAccess,
    BlockHowWork,
    BlockQuestions,
    BlockActionTime,
    BlockServiceVideo,

    bimPhoneRequest
  },

  data() {
    return {
      showModal: false,
    }
  },

  props: {
    user_info: Object,
  },
};
</script>

<style lang="scss" scoped>
.overflow-hidden {
  overflow: hidden;
}
.send-request__popup {
  ::v-deep .modal-body {
    max-height: none !important;
  }
  ::v-deep .modal-content {
    width: 100%;
  }
}
</style>
